import { useEffect, useState } from 'react';

export default function useAsyncValue<T = unknown>(fn: () => Promise<T> | undefined): T | undefined {
  const [value, setValue] = useState<T>();

  useEffect(() => {
    fn()?.then(setValue).catch(console.error);
  }, []);

  return value;
}
